<form [formGroup]="formParent">
	<span class="champs-saisie-heure">
		<input #input_heures formControlName="heures" class="input-size" type="text" maxlength="2" placeholder="hh"
			   [maxLength]="2"
			   (keypress)="controleSaisieHeures($event)"
			   (focusout)="changeHeures()"/> :
		<input #input_minutes formControlName="minutes" class="input-size" type="text" maxlength="2" placeholder="mm"
			   [maxLength]="2"
			   (keypress)="controleSaisieMinutes($event)"
			   (focusout)="changeMinutes()"/>
	</span>
</form>
